import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaEnvelope, FaPhone, FaMapMarkerAlt, FaArrowUp } from 'react-icons/fa';
import './Footer.css';
import './Footer.mobile.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="container">
        <button
          onClick={scrollToTop}
          className="footer-scroll-btn"
          aria-label="Scroll to top"
        >
          <FaArrowUp className="scroll-icon" />
          <span className="scroll-text">GO</span>
        </button>

        <div className="footer-content">
          <div className="footer-section">
            <h3>TRIOLOGY</h3>
            <p>Professional consulting services to help your business grow and succeed.</p>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61583750480170" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a> */}
              <a href="https://www.linkedin.com/company/110027157/admin/dashboard/" target="_blank" rel="noopener noreferrer">
                <FaLinkedin />
              </a>
              <a href="https://www.instagram.com/triologysolutions/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/cosmos">The Cosmos</Link></li>
              <li><Link to="/our-approach">Our Approach</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="invisible">Links</h4>
            <ul>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/who-we-work-with">Who We Work With</Link></li>
              <li><Link to="/trilogy-assessment">Trilogy Assessment</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>



          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <FaMapMarkerAlt />
                <span>Gajanan World Tourism, 2nd Floor, Siddhivinayak Apartment, Land Mark Pushparaj Chowk, Sangli</span>
              </li>
              <li>
                <FaPhone />
                <span>+91 91753 01171</span>
              </li>
              <li>
                <FaEnvelope />
                <span>thetriology.solutions@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {currentYear} TRIOLOGY. All rights reserved. |{' '}
            <a
              href="https://digisahyadri.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none' }}
              onMouseEnter={(e) => e.target.style.color = 'var(--secondary-color)'}
              onMouseLeave={(e) => e.target.style.color = 'inherit'}
            >
              Designed by DigiSahyadri
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
